<template>
  <div>
    <van-popup
      v-model="show"
      :closeable="isShowClose"
      position="top"
      close-icon="arrow-left"
      close-icon-position="top-left"
      :style="{ height: showHeigth }"
      get-container="body"
    >
      <slot></slot>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Popup2',
  props: {
    showPopup: {
      type: Boolean,
      default: false
    },
    showHeigth: {
      type: String,
      default: '100%'
    },
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    show: {
      get () {
        return this.showPopup
      },
      set (val) {
        this.$emit('close-popup')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-popup__close-icon {
		position: fixed !important;
	}
</style>



// WEBPACK FOOTER //
// src/modules/Popup2/index.vue